<template>
  <div id="app">
    <div id="nav">
      <component v-bind:is="layout">
      </component>
    </div>
  </div>
</template>

<script>
// import DashboardLayout from '@/layouts/DashboardLayout'
const default_layout = "dashboard-layout";

export default {
  name: 'app',
  computed: {
    layout () {
      return (this.$route.meta.layout || default_layout)
    }
  }
};
</script>

<style lang="scss">
  body{
    margin:0;
    overflow-x: hidden;
    #app{
      min-height: 100%
    }
  }
  .image-rounded{
    border-radius: 10px !important;
    // border: 5px solid orange;
  }
</style>
